import { render, staticRenderFns } from "./ImagesInfo.vue?vue&type=template&id=7ca96f44&scoped=true&"
import script from "./ImagesInfo.vue?vue&type=script&lang=ts&"
export * from "./ImagesInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca96f44",
  null
  
)

export default component.exports